import { Controller } from "stimulus";
import { EventFocusSearchGlobal } from "../../events";
import Lottie from "lottie-web";

export default class extends Controller {
  static targets = [ "animation" ]

  connect() {
    Lottie.loadAnimation({
      container: this.animationTarget,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: this.data.get("animation-path"),
      name: "404 Error Balloon",
    })
  }

  focusSearch(){
    window.dispatchEvent(
      new CustomEvent(EventFocusSearchGlobal, {})
    );
  }
}